import { IMAGES } from "../jsx/components/Dashboard/Content";
import tutorImage from "../images/1.jpg";
import { formatCurrency } from "../utils/utils";
import dayjs from "dayjs";

export const adminSessionsTableData = [
    {
        id: "1",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Yatin Xarma",
        studentName: "John Doe",
        sessionStatus: "Scheduled",
        scheduledDate: "02/20/2025",
        scheduledTime: "10:00 AM",
    },
    {
        id: "2",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Hanu Chang",
        studentName: "Jane Smith",
        sessionStatus: "Completed",
        scheduledDate: "02/17/2025",
        scheduledTime: "5:00 PM",
    },
    {
        id: "3",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Jordan Nico",
        studentName: "Michael Jordan",
        sessionStatus: "Canceled",
        scheduledDate: "02/22/2025",
        scheduledTime: "2:00 PM",
    },
    {
        id: "4",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Nadila Adja",
        studentName: "Emma Watson",
        sessionStatus: "Scheduled",
        scheduledDate: "02/23/2025",
        scheduledTime: "4:00 PM",
    },
    {
        id: "5",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "James Brown",
        studentName: "Alice Johnson",
        sessionStatus: "Completed",
        scheduledDate: "02/24/2025",
        scheduledTime: "9:00 AM",
    },
    {
        id: "6",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Jack John",
        studentName: "Robert Smith",
        sessionStatus: "Canceled",
        scheduledDate: "02/25/2025",
        scheduledTime: "11:00 AM",
    },
    {
        id: "7",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Tony Soap",
        studentName: "Sarah Lee",
        sessionStatus: "Missed",
        scheduledDate: "02/26/2025",
        scheduledTime: "1:00 PM",
    },
    {
        id: "8",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Yatin Xarma",
        studentName: "Tom Riddle",
        sessionStatus: "Completed",
        scheduledDate: "02/27/2024",
        scheduledTime: "3:00 PM",
    },
    {
        id: "9",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Hanu Chang",
        studentName: "Liam Neeson",
        sessionStatus: "Scheduled",
        scheduledDate: "02/28/2025",
        scheduledTime: "5:00 PM",
    },
    {
        id: "10",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Jordan Nico",
        studentName: "Eva Green",
        sessionStatus: "Missed",
        scheduledDate: "02/29/2025",
        scheduledTime: "6:00 PM",
    },
    {
        id: "11",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Nadila Adja",
        studentName: "Chris Hemsworth",
        sessionStatus: "Scheduled",
        scheduledDate: "03/01/2025",
        scheduledTime: "7:00 PM",
    },
    {
        id: "12",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "James Brown",
        studentName: "Scarlett Johansson",
        sessionStatus: "Completed",
        scheduledDate: "03/02/2025",
        scheduledTime: "8:00 PM",
    },
    {
        id: "13",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Jack John",
        studentName: "Ben Affleck",
        sessionStatus: "Canceled",
        scheduledDate: "03/03/2025",
        scheduledTime: "9:00 PM",
    },
    {
        id: "14",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Tony Soap",
        studentName: "Will Smith",
        sessionStatus: "Scheduled",
        scheduledDate: "03/04/2025",
        scheduledTime: "10:00 PM",
    },
    {
        id: "15",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Jordan Nico",
        studentName: "Matthew McConaughey",
        sessionStatus: "Scheduled",
        scheduledDate: "03/05/2025",
        scheduledTime: "11:00 PM",
    },
    {
        id: "16",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "Kohni Pandye",
        studentName: "Ryan Gosling",
        sessionStatus: "Completed",
        scheduledDate: "03/06/2025",
        scheduledTime: "12:00 AM",
    },
];

export const adminSessionsColumns = [
    {
        header: "Tutor Name",
        accessor: "tutorName",
        render: (item) => (
            <div className="trans-list">
                <img
                    src={item.tutorImage}
                    alt=""
                    className="avatar avatar-sm me-3"
                />
                <h4>{item.tutorName}</h4>
            </div>
        ),
    },
    {
        header: "Student Name",
        accessor: "studentName",
        render: (item) => (
            <div className="trans-list">
                <img
                    src={item.studentImage}
                    alt=""
                    className="avatar avatar-sm me-3"
                />
                <h4>{item.studentName}</h4>
            </div>
        ),
    },
    {
        header: "Session Status",
        accessor: "sessionStatus",
        render: (item) => (
            <span
                className={`font-w600 text-${
                    item.sessionStatus === "Canceled"
                        ? "danger"
                        : item.sessionStatus === "Scheduled"
                        ? "warning"
                        : item.sessionStatus === "Missed"
                        ? "gray"
                        : "success"
                }`}
            >
                {item.sessionStatus}
            </span>
        ),
    },
    { header: "Scheduled Date", accessor: "scheduledDate" },
    { header: "Scheduled Time", accessor: "scheduledTime" },
];
export const adminSessionsFilterConfig = [
    {
        name: "sessionStatus",
        options: ["Scheduled", "Completed", "Canceled", "Missed"],
        placeholder: "Select Status",
    },
];

export const adminSessionsSearchableColumns = ["tutorName", "studentName"];
// Admin Sessions End

// Tutor Sessions Start
export const tutorSessionsTableData = [
    {
        id: "1",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "John Doe",
        sessionStatus: "Scheduled",
        scheduledDate: "02/20/2025",
        scheduledTime: "10:00 AM",
        meetingLink: "https://meet.example.com/1",
        recordingLink: "https://recording.example.com/1",
    },
    {
        id: "2",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Jane Smith",
        sessionStatus: "Completed",
        scheduledDate: "02/17/2025",
        scheduledTime: "5:00 PM",
        meetingLink: "https://meet.example.com/2",
        recordingLink: "https://recording.example.com/2",
    },
    {
        id: "3",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Michael Jordan",
        sessionStatus: "Canceled",
        scheduledDate: "02/22/2025",
        scheduledTime: "2:00 PM",
        meetingLink: "https://meet.example.com/3",
        recordingLink: "https://recording.example.com/3",
    },
    {
        id: "4",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Emma Watson",
        sessionStatus: "Scheduled",
        scheduledDate: "02/23/2025",
        scheduledTime: "4:00 PM",
        meetingLink: "https://meet.example.com/4",
        recordingLink: "https://recording.example.com/4",
    },
    {
        id: "5",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Alice Johnson",
        sessionStatus: "Completed",
        scheduledDate: "02/24/2025",
        scheduledTime: "9:00 AM",
        meetingLink: "https://meet.example.com/5",
        recordingLink: "https://recording.example.com/5",
    },
    {
        id: "6",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Robert Smith",
        sessionStatus: "Canceled",
        scheduledDate: "02/25/2025",
        scheduledTime: "11:00 AM",
        meetingLink: "https://meet.example.com/6",
        recordingLink: "https://recording.example.com/6",
    },
    {
        id: "7",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Sarah Lee",
        sessionStatus: "Scheduled",
        scheduledDate: "02/26/2025",
        scheduledTime: "1:00 PM",
        meetingLink: "https://meet.example.com/7",
        recordingLink: "https://recording.example.com/7",
    },
    {
        id: "8",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Tom Riddle",
        sessionStatus: "Completed",
        scheduledDate: "02/27/2025",
        scheduledTime: "3:00 PM",
        meetingLink: "https://meet.example.com/8",
        recordingLink: "https://recording.example.com/8",
    },
    {
        id: "9",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Liam Neeson",
        sessionStatus: "Scheduled",
        scheduledDate: "02/28/2025",
        scheduledTime: "5:00 PM",
        meetingLink: "https://meet.example.com/9",
        recordingLink: "https://recording.example.com/9",
    },
    {
        id: "10",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Eva Green",
        sessionStatus: "Missed",
        scheduledDate: "02/29/2025",
        scheduledTime: "6:00 PM",
        meetingLink: "https://meet.example.com/10",
        recordingLink: "https://recording.example.com/10",
    },
    {
        id: "11",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Chris Hemsworth",
        sessionStatus: "Scheduled",
        scheduledDate: "03/01/2025",
        scheduledTime: "7:00 PM",
        meetingLink: "https://meet.example.com/11",
        recordingLink: "https://recording.example.com/11",
    },
    {
        id: "12",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Scarlett Johansson",
        sessionStatus: "Completed",
        scheduledDate: "03/02/2025",
        scheduledTime: "8:00 PM",
        meetingLink: "https://meet.example.com/12",
        recordingLink: "https://recording.example.com/12",
    },
    {
        id: "13",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Ben Affleck",
        sessionStatus: "Canceled",
        scheduledDate: "03/03/2025",
        scheduledTime: "9:00 PM",
        meetingLink: "https://meet.example.com/13",
        recordingLink: "https://recording.example.com/13",
    },
    {
        id: "14",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Will Smith",
        sessionStatus: "Missed",
        scheduledDate: "03/04/2025",
        scheduledTime: "10:00 PM",
        meetingLink: "https://meet.example.com/14",
        recordingLink: "https://recording.example.com/14",
    },
    {
        id: "15",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Matthew McConaughey",
        sessionStatus: "Scheduled",
        scheduledDate: "03/05/2025",
        scheduledTime: "11:00 PM",
        meetingLink: "https://meet.example.com/15",
        recordingLink: "https://recording.example.com/15",
    },
    {
        id: "16",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Ryan Gosling",
        sessionStatus: "Completed",
        scheduledDate: "03/06/2025",
        scheduledTime: "12:00 AM",
        meetingLink: "https://meet.example.com/16",
        recordingLink: "https://recording.example.com/16",
    },
    {
        id: "17",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "John Evergreen",
        sessionStatus: "Scheduled",
        scheduledDate: "02/20/2025",
        scheduledTime: "10:00 AM",
        meetingLink: "https://meet.example.com/1",
        recordingLink: "https://recording.example.com/1",
    },
    {
        id: "18",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Scarlett Moonstone",
        sessionStatus: "Completed",
        scheduledDate: "03/02/2025",
        scheduledTime: "8:00 PM",
        meetingLink: "https://meet.example.com/12",
        recordingLink: "https://recording.example.com/12",
    },
    {
        id: "19",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Chris Nightfall",
        sessionStatus: "Scheduled",
        scheduledDate: "03/01/2025",
        scheduledTime: "7:00 PM",
        meetingLink: "https://meet.example.com/11",
        recordingLink: "https://recording.example.com/11",
    },
    {
        id: "20",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Matthew Starling",
        sessionStatus: "Scheduled",
        scheduledDate: "03/05/2025",
        scheduledTime: "11:00 PM",
        meetingLink: "https://meet.example.com/15",
        recordingLink: "https://recording.example.com/15",
    },
    {
        id: "21",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Alice Ember",
        sessionStatus: "Completed",
        scheduledDate: "02/24/2025",
        scheduledTime: "9:00 AM",
        meetingLink: "https://meet.example.com/5",
        recordingLink: "https://recording.example.com/5",
    },
    {
        id: "22",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Robert Ironwood",
        sessionStatus: "Canceled",
        scheduledDate: "02/25/2025",
        scheduledTime: "11:00 AM",
        meetingLink: "https://meet.example.com/6",
        recordingLink: "https://recording.example.com/6",
    },
    {
        id: "23",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Sarah Winter",
        sessionStatus: "Scheduled",
        scheduledDate: "02/26/2025",
        scheduledTime: "1:00 PM",
        meetingLink: "https://meet.example.com/7",
        recordingLink: "https://recording.example.com/7",
    },
    {
        id: "24",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Tom Storm",
        sessionStatus: "Completed",
        scheduledDate: "02/27/2025",
        scheduledTime: "3:00 PM",
        meetingLink: "https://meet.example.com/8",
        recordingLink: "https://recording.example.com/8",
    },
    {
        id: "25",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Liam Fox",
        sessionStatus: "Scheduled",
        scheduledDate: "02/28/2025",
        scheduledTime: "5:00 PM",
        meetingLink: "https://meet.example.com/9",
        recordingLink: "https://recording.example.com/9",
    },
    {
        id: "26",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Eva Solstice",
        sessionStatus: "Missed",
        scheduledDate: "02/29/2025",
        scheduledTime: "6:00 PM",
        meetingLink: "https://meet.example.com/10",
        recordingLink: "https://recording.example.com/10",
    },
    {
        id: "27",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Michael Redwood",
        sessionStatus: "Canceled",
        scheduledDate: "02/22/2025",
        scheduledTime: "2:00 PM",
        meetingLink: "https://meet.example.com/3",
        recordingLink: "https://recording.example.com/3",
    },
    {
        id: "28",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Jane Marigold",
        sessionStatus: "Completed",
        scheduledDate: "02/17/2025",
        scheduledTime: "5:00 PM",
        meetingLink: "https://meet.example.com/2",
        recordingLink: "https://recording.example.com/2",
    },
    {
        id: "29",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Ben Shadow",
        sessionStatus: "Canceled",
        scheduledDate: "03/03/2025",
        scheduledTime: "9:00 PM",
        meetingLink: "https://meet.example.com/13",
        recordingLink: "https://recording.example.com/13",
    },
    {
        id: "30",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Will Phoenix",
        sessionStatus: "Missed",
        scheduledDate: "03/04/2025",
        scheduledTime: "10:00 PM",
        meetingLink: "https://meet.example.com/14",
        recordingLink: "https://recording.example.com/14",
    },
    {
        id: "31",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Emma Lark",
        sessionStatus: "Scheduled",
        scheduledDate: "02/23/2025",
        scheduledTime: "4:00 PM",
        meetingLink: "https://meet.example.com/4",
        recordingLink: "https://recording.example.com/4",
    },
    {
        id: "32",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        tutorName: "John Smith",
        studentName: "Ryan Falconer",
        sessionStatus: "Completed",
        scheduledDate: "03/06/2025",
        scheduledTime: "12:00 AM",
        meetingLink: "https://meet.example.com/16",
        recordingLink: "https://recording.example.com/16",
    },
];

export const tutorSessionsUpcomingColumns = [
    { header: "Tutor Name", accessor: "tutorName" },
    { header: "Student Name", accessor: "studentName" },
    {
        header: "Session Status",
        accessor: "sessionStatus",
        render: (item) => (
            <span
                className={`font-w600 text-${
                    item.sessionStatus === "Canceled"
                        ? "danger"
                        : item.sessionStatus === "Scheduled"
                        ? "warning"
                        : item.sessionStatus === "Missed"
                        ? "gray"
                        : "success"
                }`}
            >
                {item.sessionStatus}
            </span>
        ),
    },
    { header: "Scheduled Date", accessor: "scheduledDate" },
    { header: "Scheduled Time", accessor: "scheduledTime" },
    {
        header: "Meeting Link",
        accessor: "meetingLink",
        render: (item) => (
            <a
                href={item.meetingLink}
                target="_blank"
                rel="noopener noreferrer"
            >
                Join Meeting
            </a>
        ),
    },
];

export const tutorSessionsHistoryColumns = [
    { header: "Tutor Name", accessor: "tutorName" },
    { header: "Student Name", accessor: "studentName" },
    {
        header: "Session Status",
        accessor: "sessionStatus",
        render: (item) => (
            <span
                className={`font-w600 text-${
                    item.sessionStatus === "Canceled"
                        ? "danger"
                        : item.sessionStatus === "Scheduled"
                        ? "warning"
                        : item.sessionStatus === "Missed"
                        ? "gray"
                        : "success"
                }`}
            >
                {item.sessionStatus}
            </span>
        ),
    },
    { header: "Scheduled Date", accessor: "scheduledDate" },
    { header: "Scheduled Time", accessor: "scheduledTime" },
    {
        header: "Recording Link",
        accessor: "recordingLink",
        render: (item) => (
            <a
                href={item.recordingLink}
                target="_blank"
                rel="noopener noreferrer"
            >
                View Recording
            </a>
        ),
    },
];

export const tutorSessionsHistoryFilterConfig = [
    {
        name: "sessionStatus",
        options: ["Completed", "Cancelled", "Missed"],
        placeholder: "Select Status",
    },
];

export const tutorList = [
    {
        id: 1,
        image: IMAGES.contact1,
        Role: "Tutor",
        Name: "Munaroh Steffani",
        Expertise: ["English"],
    },
    {
        id: 2,
        image: IMAGES.contact2,
        Role: "Tutor",
        Name: "Geovanny Anderson",
        Expertise: ["Spanish"],
    },
    {
        id: 3,
        image: IMAGES.contact3,
        Role: "Tutor",
        Name: "Louis Ali",
        Expertise: ["English", "French"],
    },
    {
        id: 4,
        image: IMAGES.contact4,
        Role: "Tutor",
        Name: "Marquezz",
        Expertise: ["French"],
    },
    {
        id: 5,
        image: IMAGES.contact5,
        Role: "Tutor",
        Name: "Richard",
        Expertise: ["Arabic", "English"],
    },
    {
        id: 6,
        image: IMAGES.contact6,
        Role: "Tutor",
        Name: "Andrew Stevano",
        Expertise: ["Spanish"],
    },
    {
        id: 7,
        image: IMAGES.contact7,
        Role: "Tutor",
        Name: "Cathenna",
        Expertise: ["English", "Spanish"],
    },
    {
        id: 8,
        image: IMAGES.contact8,
        Role: "Tutor",
        Name: "Hrisovalantis",
        Expertise: ["Spanish", "French"],
    },
    {
        id: 9,
        image: IMAGES.contact9,
        Role: "Tutor",
        Name: "Louis Ali",
        Expertise: ["English"],
    },
    {
        id: 10,
        image: IMAGES.contact10,
        Role: "Tutor",
        Name: "Marquezz",
        Expertise: ["French", "Arabic"],
    },
    {
        id: 11,
        image: IMAGES.contact11,
        Role: "Tutor",
        Name: "Richard",
        Expertise: ["English", "French"],
    },
    {
        id: 12,
        image: IMAGES.contact12,
        Role: "Tutor",
        Name: "Andrew Stevano",
        Expertise: ["French", "Spanish"],
    },
];

// BookSession Start
export const proficiencyLabels = {
    0: "Not Selected",
    1: "Beginner",
    2: "Elementary",
    3: "Intermediate",
    4: "Advanced",
    5: "Proficient",
};

// BookSession End
export const subjects = [
    { id: 1, name: "English" },
    { id: 2, name: "Spanish" },
    { id: 3, name: "Arabic" },
    { id: 4, name: "French" },
    { id: 5, name: "Urdu" },
];

// Student Session Start
// Tutor Sessions Start
export const studentSessionsTableData = [
    {
        id: "1",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "John Doe",
        sessionStatus: "Scheduled",
        scheduledDate: "02/20/2025",
        scheduledTime: "10:00 AM",
        meetingLink: "https://meet.example.com/1",
        recordingLink: "https://recording.example.com/1",
    },
    {
        id: "2",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Jane Smith",
        sessionStatus: "Completed",
        scheduledDate: "02/17/2025",
        scheduledTime: "5:00 PM",
        meetingLink: "https://meet.example.com/2",
        recordingLink: "https://recording.example.com/2",
    },
    {
        id: "3",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Michael Jordan",
        sessionStatus: "Canceled",
        scheduledDate: "02/22/2025",
        scheduledTime: "2:00 PM",
        meetingLink: "https://meet.example.com/3",
        recordingLink: "https://recording.example.com/3",
    },
    {
        id: "4",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Emma Watson",
        sessionStatus: "Scheduled",
        scheduledDate: "02/23/2025",
        scheduledTime: "4:00 PM",
        meetingLink: "https://meet.example.com/4",
        recordingLink: "https://recording.example.com/4",
    },
    {
        id: "5",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Alice Johnson",
        sessionStatus: "Completed",
        scheduledDate: "02/24/2025",
        scheduledTime: "9:00 AM",
        meetingLink: "https://meet.example.com/5",
        recordingLink: "https://recording.example.com/5",
    },
    {
        id: "6",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Robert Smith",
        sessionStatus: "Canceled",
        scheduledDate: "02/25/2025",
        scheduledTime: "11:00 AM",
        meetingLink: "https://meet.example.com/6",
        recordingLink: "https://recording.example.com/6",
    },
    {
        id: "7",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Sarah Lee",
        sessionStatus: "Scheduled",
        scheduledDate: "02/26/2025",
        scheduledTime: "1:00 PM",
        meetingLink: "https://meet.example.com/7",
        recordingLink: "https://recording.example.com/7",
    },
    {
        id: "8",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Tom Riddle",
        sessionStatus: "Completed",
        scheduledDate: "02/27/2025",
        scheduledTime: "3:00 PM",
        meetingLink: "https://meet.example.com/8",
        recordingLink: "https://recording.example.com/8",
    },
    {
        id: "9",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Liam Neeson",
        sessionStatus: "Scheduled",
        scheduledDate: "02/28/2025",
        scheduledTime: "5:00 PM",
        meetingLink: "https://meet.example.com/9",
        recordingLink: "https://recording.example.com/9",
    },
    {
        id: "10",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Eva Green",
        sessionStatus: "Missed",
        scheduledDate: "02/29/2025",
        scheduledTime: "6:00 PM",
        meetingLink: "https://meet.example.com/10",
        recordingLink: "https://recording.example.com/10",
    },
    {
        id: "11",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Chris Hemsworth",
        sessionStatus: "Scheduled",
        scheduledDate: "03/01/2025",
        scheduledTime: "7:00 PM",
        meetingLink: "https://meet.example.com/11",
        recordingLink: "https://recording.example.com/11",
    },
    {
        id: "12",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Scarlett Johansson",
        sessionStatus: "Completed",
        scheduledDate: "03/02/2025",
        scheduledTime: "8:00 PM",
        meetingLink: "https://meet.example.com/12",
        recordingLink: "https://recording.example.com/12",
    },
    {
        id: "13",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Ben Affleck",
        sessionStatus: "Canceled",
        scheduledDate: "03/03/2025",
        scheduledTime: "9:00 PM",
        meetingLink: "https://meet.example.com/13",
        recordingLink: "https://recording.example.com/13",
    },
    {
        id: "14",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Will Smith",
        sessionStatus: "Missed",
        scheduledDate: "03/04/2025",
        scheduledTime: "10:00 PM",
        meetingLink: "https://meet.example.com/14",
        recordingLink: "https://recording.example.com/14",
    },
    {
        id: "15",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Matthew McConaughey",
        sessionStatus: "Scheduled",
        scheduledDate: "03/05/2025",
        scheduledTime: "11:00 PM",
        meetingLink: "https://meet.example.com/15",
        recordingLink: "https://recording.example.com/15",
    },
    {
        id: "16",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Ryan Gosling",
        sessionStatus: "Completed",
        scheduledDate: "03/06/2025",
        scheduledTime: "12:00 AM",
        meetingLink: "https://meet.example.com/16",
        recordingLink: "https://recording.example.com/16",
    },
    {
        id: "17",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "John Evergreen",
        sessionStatus: "Scheduled",
        scheduledDate: "02/20/2025",
        scheduledTime: "10:00 AM",
        meetingLink: "https://meet.example.com/1",
        recordingLink: "https://recording.example.com/1",
    },
    {
        id: "18",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Scarlett Moonstone",
        sessionStatus: "Completed",
        scheduledDate: "03/02/2025",
        scheduledTime: "8:00 PM",
        meetingLink: "https://meet.example.com/12",
        recordingLink: "https://recording.example.com/12",
    },
    {
        id: "19",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Chris Nightfall",
        sessionStatus: "Scheduled",
        scheduledDate: "03/01/2025",
        scheduledTime: "7:00 PM",
        meetingLink: "https://meet.example.com/11",
        recordingLink: "https://recording.example.com/11",
    },
    {
        id: "20",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Matthew Starling",
        sessionStatus: "Scheduled",
        scheduledDate: "03/05/2025",
        scheduledTime: "11:00 PM",
        meetingLink: "https://meet.example.com/15",
        recordingLink: "https://recording.example.com/15",
    },
    {
        id: "21",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Alice Ember",
        sessionStatus: "Completed",
        scheduledDate: "02/24/2025",
        scheduledTime: "9:00 AM",
        meetingLink: "https://meet.example.com/5",
        recordingLink: "https://recording.example.com/5",
    },
    {
        id: "22",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Robert Ironwood",
        sessionStatus: "Canceled",
        scheduledDate: "02/25/2025",
        scheduledTime: "11:00 AM",
        meetingLink: "https://meet.example.com/6",
        recordingLink: "https://recording.example.com/6",
    },
    {
        id: "23",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Sarah Winter",
        sessionStatus: "Scheduled",
        scheduledDate: "02/26/2025",
        scheduledTime: "1:00 PM",
        meetingLink: "https://meet.example.com/7",
        recordingLink: "https://recording.example.com/7",
    },
    {
        id: "24",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Tom Storm",
        sessionStatus: "Completed",
        scheduledDate: "02/27/2025",
        scheduledTime: "3:00 PM",
        meetingLink: "https://meet.example.com/8",
        recordingLink: "https://recording.example.com/8",
    },
    {
        id: "25",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Liam Fox",
        sessionStatus: "Scheduled",
        scheduledDate: "02/28/2025",
        scheduledTime: "5:00 PM",
        meetingLink: "https://meet.example.com/9",
        recordingLink: "https://recording.example.com/9",
    },
    {
        id: "26",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Eva Solstice",
        sessionStatus: "Missed",
        scheduledDate: "02/29/2025",
        scheduledTime: "6:00 PM",
        meetingLink: "https://meet.example.com/10",
        recordingLink: "https://recording.example.com/10",
    },
    {
        id: "27",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Michael Redwood",
        sessionStatus: "Canceled",
        scheduledDate: "02/22/2025",
        scheduledTime: "2:00 PM",
        meetingLink: "https://meet.example.com/3",
        recordingLink: "https://recording.example.com/3",
    },
    {
        id: "28",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Jane Marigold",
        sessionStatus: "Completed",
        scheduledDate: "02/17/2025",
        scheduledTime: "5:00 PM",
        meetingLink: "https://meet.example.com/2",
        recordingLink: "https://recording.example.com/2",
    },
    {
        id: "29",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Ben Shadow",
        sessionStatus: "Canceled",
        scheduledDate: "03/03/2025",
        scheduledTime: "9:00 PM",
        meetingLink: "https://meet.example.com/13",
        recordingLink: "https://recording.example.com/13",
    },
    {
        id: "30",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Will Phoenix",
        sessionStatus: "Missed",
        scheduledDate: "03/04/2025",
        scheduledTime: "10:00 PM",
        meetingLink: "https://meet.example.com/14",
        recordingLink: "https://recording.example.com/14",
    },
    {
        id: "31",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Emma Lark",
        sessionStatus: "Scheduled",
        scheduledDate: "02/23/2025",
        scheduledTime: "4:00 PM",
        meetingLink: "https://meet.example.com/4",
        recordingLink: "https://recording.example.com/4",
    },
    {
        id: "32",
        studentImage: IMAGES.trans1,
        tutorImage: IMAGES.trans2,
        studentName: "John Smith",
        tutorName: "Ryan Falconer",
        sessionStatus: "Completed",
        scheduledDate: "03/06/2025",
        scheduledTime: "12:00 AM",
        meetingLink: "https://meet.example.com/16",
        recordingLink: "https://recording.example.com/16",
    },
];

export const dummySubjects = [
    { id: 1, name: "Mathematics", color: "#E3F2FD" },
    { id: 2, name: "Physics", color: "#F3E5F5" },
    { id: 3, name: "Chemistry", color: "#E8F5E9" },
    { id: 4, name: "Biology", color: "#FFF3E0" },
];

export const dummyWeeklyHours = {
    Sun: { enabled: false, slots: [], errors: {} },
    Mon: {
        enabled: true,
        slots: [{ startTime: "09:00", endTime: "17:00", subject: 1 }],
        errors: {},
    },
    Tue: {
        enabled: true,
        slots: [{ startTime: "09:00", endTime: "17:00", subject: 2 }],
        errors: {},
    },
    Wed: {
        enabled: true,
        slots: [{ startTime: "09:00", endTime: "17:00", subject: 1 }],
        errors: {},
    },
    Thu: {
        enabled: true,
        slots: [{ startTime: "09:00", endTime: "17:00", subject: 3 }],
        errors: {},
    },
    Fri: {
        enabled: true,
        slots: [{ startTime: "09:00", endTime: "17:00", subject: 4 }],
        errors: {},
    },
    Sat: { enabled: false, slots: [], errors: {} },
};

export const tutorAvailabilityData = [
    {
        day: "Monday",
        slots: [
            "09:00 AM - 10:00 AM",
            "02:00 PM - 03:00 PM",
            "06:00 PM - 07:00 PM",
        ],
    },
    {
        day: "Tuesday",
        slots: ["10:00 AM - 11:00 AM", "03:00 PM - 04:00 PM"],
    },
    {
        day: "Wednesday",
        slots: [
            "09:00 AM - 10:00 AM",
            "01:00 PM - 02:00 PM",
            "05:00 PM - 06:00 PM",
        ],
    },
    {
        day: "Thursday",
        slots: ["11:00 AM - 12:00 PM", "04:00 PM - 05:00 PM"],
    },
    {
        day: "Friday",
        slots: ["10:00 AM - 11:00 AM", "03:00 PM - 04:00 PM"],
    },
    {
        day: "Saturday",
        slots: ["09:00 AM - 10:00 AM", "02:00 PM - 03:00 PM"],
    },
    { day: "Sunday", slots: [] },
];

//transactions admin view
export const transactionsColumns = [
    {
        header: "Transaction ID",
        accessor: "transactionId",
        render: (item) => (
            <span className="text-primary">#{item.transactionId}</span>
        ),
    },
    {
        header: "Date",
        accessor: "date",
        render: (item) => new Date(item.date).toLocaleDateString(),
    },
    {
        header: "Student",
        accessor: "studentName",
    },
    {
        header: "Session",
        accessor: "sessionTitle",
    },
    {
        header: "Amount",
        accessor: "amount",
        render: (item) => (
            <span className="font-weight-bold">
                {formatCurrency(item.amount)}
            </span>
        ),
    },
    {
        header: "Payment Status",
        accessor: "paymentStatus",
        render: (item) => {
            let badgeClass = "";
            switch (item.paymentStatus) {
                case "Paid":
                    badgeClass = "badge-success";
                    break;
                case "Pending":
                    badgeClass = "badge-warning";
                    break;
                case "Cancelled":
                    badgeClass = "badge-danger";
                    break;
                default:
                    badgeClass = "badge-secondary";
            }
            return (
                <span className={`badge ${badgeClass}`}>
                    {item.paymentStatus}
                </span>
            );
        },
    },
    {
        header: "Payment Method",
        accessor: "paymentMethod",
    },
];

export const billingsColumns = [
    {
        header: "Billing ID",
        accessor: "billingId",
        render: (item) => (
            <span className="text-primary">#{item.billingId}</span>
        ),
    },
    {
        header: "Date",
        accessor: "date",
        render: (item) => new Date(item.date).toLocaleDateString(),
    },
    {
        header: "Student",
        accessor: "studentName",
    },
    {
        header: "Session",
        accessor: "sessionTitle",
    },
    {
        header: "Amount",
        accessor: "amount",
        render: (item) => (
            <span className="font-weight-bold">
                {formatCurrency(item.amount)}
            </span>
        ),
    },
    {
        header: "Payment Status",
        accessor: "paymentStatus",
        render: (item) => {
            let badgeClass = "";
            switch (item.paymentStatus) {
                case "Paid":
                    badgeClass = "badge-success";
                    break;
                case "Pending":
                    badgeClass = "badge-warning";
                    break;
                case "Cancelled":
                    badgeClass = "badge-danger";
                    break;
                default:
                    badgeClass = "badge-secondary";
            }
            return (
                <span className={`badge ${badgeClass}`}>
                    {item.paymentStatus}
                </span>
            );
        },
    },
    {
        header: "Payment Method",
        accessor: "paymentMethod",
    },
];

export const transactionsfilterConfig = [
    {
        name: "paymentStatus",
        options: ["Paid", "Pending", "Cancelled"],
        placeholder: "Payment Status",
    },
    {
        name: "paymentMethod",
        options: ["Stripe", "Paystack"], // Add your supported payment methods
        placeholder: "Payment Method",
    },
];

export const sampleTransactions = [
    {
        id: 1,
        transactionId: "TRX001",
        date: "2025-03-10T08:30:00",
        studentName: "John Smith",
        sessionTitle: "Advanced Calculus",
        amount: 75.0,
        paymentStatus: "Paid",
        paymentMethod: "Stripe",
        scheduledDate: "2025-03-10",
        scheduledTime: "08:30:00",
        sessionStatus: "Completed",
    },
    {
        id: 2,
        transactionId: "TRX002",
        date: "2025-03-12T14:15:00",
        studentName: "Maria Garcia",
        sessionTitle: "English Literature",
        amount: 60.0,
        paymentStatus: "Pending",
        paymentMethod: "Paystack",
        scheduledDate: "2025-03-15",
        scheduledTime: "14:15:00",
        sessionStatus: "Scheduled",
    },
    {
        id: 3,
        transactionId: "TRX003",
        date: "2025-03-08T16:00:00",
        studentName: "Alex Johnson",
        sessionTitle: "Physics Fundamentals",
        amount: 80.0,
        paymentStatus: "Cancelled",
        paymentMethod: "Stripe",
        scheduledDate: "2025-03-08",
        scheduledTime: "16:00:00",
        sessionStatus: "Cancelled",
    },
    {
        id: 4,
        transactionId: "TRX004",
        date: "2025-03-13T10:45:00",
        studentName: "Sophie Williams",
        sessionTitle: "Spanish Conversation",
        amount: 55.0,
        paymentStatus: "Paid",
        paymentMethod: "Paystack",
        scheduledDate: "2025-03-13",
        scheduledTime: "10:45:00",
        sessionStatus: "Completed",
    },
    {
        id: 5,
        transactionId: "TRX005",
        date: "2025-03-14T13:30:00",
        studentName: "James Chen",
        sessionTitle: "Chemistry Tutoring",
        amount: 70.0,
        paymentStatus: "Pending",
        paymentMethod: "Stripe",
        scheduledDate: "2025-03-14",
        scheduledTime: "13:30:00",
        sessionStatus: "Scheduled",
    },
];
export const sampleBillings = [
    {
        id: 1,
        billingId: "001",
        date: "2025-03-10T08:30:00",
        studentName: "John Smith",
        sessionTitle: "Advanced Calculus",
        amount: 75.0,
        paymentStatus: "Paid",
        paymentMethod: "Stripe",
        scheduledDate: "2025-03-10",
        scheduledTime: "08:30:00",
        sessionStatus: "Completed",
    },
    {
        id: 2,
        billingId: "002",
        date: "2025-03-12T14:15:00",
        studentName: "Maria Garcia",
        sessionTitle: "English Literature",
        amount: 60.0,
        paymentStatus: "Pending",
        paymentMethod: "Paystack",
        scheduledDate: "2025-03-15",
        scheduledTime: "14:15:00",
        sessionStatus: "Scheduled",
    },
    {
        id: 3,
        billingId: "003",
        date: "2025-03-08T16:00:00",
        studentName: "Alex Johnson",
        sessionTitle: "Physics Fundamentals",
        amount: 80.0,
        paymentStatus: "Cancelled",
        paymentMethod: "Stripe",
        scheduledDate: "2025-03-08",
        scheduledTime: "16:00:00",
        sessionStatus: "Cancelled",
    },
    {
        id: 4,
        billingId: "004",
        date: "2025-03-13T10:45:00",
        studentName: "Sophie Williams",
        sessionTitle: "Spanish Conversation",
        amount: 55.0,
        paymentStatus: "Paid",
        paymentMethod: "Paystack",
        scheduledDate: "2025-03-13",
        scheduledTime: "10:45:00",
        sessionStatus: "Completed",
    },
    {
        id: 5,
        billingId: "005",
        date: "2025-03-14T13:30:00",
        studentName: "James Chen",
        sessionTitle: "Chemistry Tutoring",
        amount: 70.0,
        paymentStatus: "Pending",
        paymentMethod: "Stripe",
        scheduledDate: "2025-03-14",
        scheduledTime: "13:30:00",
        sessionStatus: "Scheduled",
    },
];

//student payment method
export const dummyPaymentMethods = [
    {
        id: "1",
        type: "visa",
        last4: "4242",
        expiryDate: "12/24",
        isDefault: true,
        cardholderName: "John Doe",
    },
    {
        id: "2",
        type: "mastercard",
        last4: "5555",
        expiryDate: "10/25",
        isDefault: false,
        cardholderName: "John Doe",
    },
];

export const studentData = {
    id: "STD1001",
    name: "Alex Johnson",
    profileImage: tutorImage,
    about: "I'm a high school student passionate about learning spanish and french",
    currentEducation: {
        level: "High School",
        institution: "Westside High School",
        year: "Senior (12th Grade)",
    },
    joinedDate: "Jan 2023",
    totalSessions: 15,
    languagesOfInterest: ["English", "Spanish", "French"],
    languages: ["English", "Spanish"],
    email: "alex.johnson@example.com",
    phone: "(555) 123-4567",
    location: "Chicago, IL",
    parentContact: {
        name: "Sarah Johnson",
        email: "sarah.johnson@example.com",
        phone: "(555) 123-4568",
    },
    sessions: [
        {
            id: "SES1001",
            subject: "AP Calculus",
            subjectIcon: "calculator",
            tutorName: "Dr. Robert Chen",
            tutorId: "TUT1005",
            date: "Mar 15, 2025",
            time: "4:00 PM - 5:30 PM",
            status: "Scheduled",
        },
        {
            id: "SES982",
            subject: "Physics",
            subjectIcon: "atom",
            tutorName: "Jennifer Lopez",
            tutorId: "TUT1002",
            date: "Mar 12, 2025",
            time: "5:00 PM - 6:00 PM",
            status: "Completed",
            rating: 4.5,
        },
        {
            id: "SES951",
            subject: "Computer Science",
            subjectIcon: "laptop-code",
            tutorName: "Michael Black",
            tutorId: "TUT1008",
            date: "Mar 5, 2025",
            time: "4:30 PM - 6:00 PM",
            status: "Completed",
            rating: 5.0,
        },
        {
            id: "SES920",
            subject: "Chemistry",
            subjectIcon: "flask",
            tutorName: "Sofia Rodriguez",
            tutorId: "TUT1012",
            date: "Feb 28, 2025",
            time: "3:30 PM - 5:00 PM",
            status: "Completed",
            rating: 4.0,
        },
    ],
};

export const dummyPermissions = [
    {
        id: "dashboard",
        label: "Dashboard",
        checked: true,
        children: [],
    },
    {
        id: "content-management",
        label: "Content Management",
        checked: true,
        children: [
            {
                id: "languages",
                label: "Languages",
                checked: true,
                children: [
                    {
                        id: "add-language",
                        label: "- Add Language",
                        checked: true,
                        children: [],
                    },
                    {
                        id: "update-language",
                        label: "- Update Language",
                        checked: true,
                        children: [],
                    },
                ],
            },
            {
                id: "levels",
                label: "Levels",
                checked: true,
                children: [
                    {
                        id: "add-level",
                        label: "- Add Level",
                        checked: true,
                        children: [],
                    },
                    {
                        id: "update-level",
                        label: "- Update Level",
                        checked: true,
                        children: [],
                    },
                ],
            },
            {
                id: "lessons",
                label: "Lessons",
                checked: true,
                children: [
                    {
                        id: "add-lesson",
                        label: "- Add Lesson",
                        checked: true,
                        children: [],
                    },
                    {
                        id: "update-lesson",
                        label: "- Update Lesson",
                        checked: true,
                        children: [],
                    },
                ],
            },
            {
                id: "quick-matches",
                label: "Quick Matches",
                checked: true,
                children: [
                    {
                        id: "add-quick-match",
                        label: "- Add Quick Match",
                        checked: true,
                        children: [],
                    },
                    {
                        id: "update-quick-match",
                        label: "- Update Quick Match",
                        checked: true,
                        children: [],
                    },
                ],
            },
            {
                id: "flash-cards",
                label: "Flash Cards",
                checked: true,
                children: [
                    {
                        id: "add-flash-card",
                        label: "- Add Flash Card",
                        checked: true,
                        children: [],
                    },
                    {
                        id: "update-flash-card",
                        label: "- Update Flash Card",
                        checked: true,
                        children: [],
                    },
                ],
            },
            {
                id: "sound-table",
                label: "Sound Table",
                checked: true,
                children: [
                    {
                        id: "add-sound-table",
                        label: "- Add Sound Table",
                        checked: true,
                        children: [],
                    },
                    {
                        id: "update-sound-table",
                        label: "- Update Sound Table",
                        checked: true,
                        children: [],
                    },
                ],
            },
            {
                id: "afrobeats",
                label: "Afrobeats",
                checked: true,
                children: [],
            },
        ],
    },
    {
        id: "subscriptions",
        label: "Subscriptions",
        checked: true,
        children: [
            {
                id: "payment-history",
                label: "Payment History",
                checked: true,
                children: [],
            },
            { id: "revenue", label: "Revenue", checked: true, children: [] },
            {
                id: "free-access-users",
                label: "Free Access Users",
                checked: true,
                children: [],
            },
        ],
    },
    {
        id: "system-management",
        label: "System Management",
        checked: true,
        children: [
            {
                id: "users-management",
                label: "Users Management",
                checked: true,
                children: [],
            },
            {
                id: "roles-management",
                label: "Roles Management",
                checked: true,
                children: [],
            },
        ],
    },
    {
        id: "app-users",
        label: "App Users",
        checked: true,
        children: [],
    },
    {
        id: "demographics",
        label: "Demographics",
        checked: true,
        children: [],
    },
    {
        id: "reports",
        label: "Reports",
        checked: true,
        children: [],
    },
];

export const mockSlots = [
    { id: 1, duration: 30, name: "Half Hour", rate: 25 },
    { id: 2, duration: 60, name: "One Hour", rate: 45 },
    { id: 3, duration: 90, name: "Extended (90 min)", rate: 65 },
];

export const mockBookedSlots = [
    {
        // id: 1,
        // date: "2025-03-27",
        startTime: "2024-03-27T09:00:00Z",
        endTime: "2024-03-27T10:00:00Z",
        // available: false,
        subjectId: null,
        proficiency: 0,
        expanded: false,
    },
    {
        id: 2,
        date: "2025-03-27",
        startTime: "2024-03-27T16:45:00+05:00",
        endTime: "2024-03-27T18:15:00+05:00",
        // available: false,
        subjectId: null,
        proficiency: 0,
        expanded: false,
    },
];

export const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
];

export const educationOptions = [
    { value: "", label: "Select Education" },
    { value: "High School", label: "High School" },
    { value: "Bachelor's Degree", label: "Bachelor's Degree" },
    { value: "Master's Degree", label: "Master's Degree" },
    { value: "PhD", label: "PhD" },
];

export const timezoneOptions = [
    { value: "EST", label: "EST (Eastern Standard Time)" },
    { value: "CST", label: "CST (Central Standard Time)" },
    { value: "MST", label: "MST (Mountain Standard Time)" },
    { value: "PST", label: "PST (Pacific Standard Time)" },
];
// Sample reviews data
export const sampleReviews = [
    {
        id: 1,
        studentName: "Emily Johnson",
        studentAvatar: IMAGES.trans1,
        rating: 5,
        date: "March 15, 2024",
        comment:
            "Great tutor! Helped me improve my English pronunciation and grammar significantly.",
        subject: "English",
    },
    {
        id: 2,
        studentName: "Michael Chen",
        studentAvatar: IMAGES.trans1,
        rating: 4,
        date: "February 22, 2024",
        comment:
            "Very patient and knowledgeable. Made learning Mandarin much easier with practical examples.",
        subject: "Mandarin",
    },
    {
        id: 3,
        studentName: "Sarah Rodriguez",
        studentAvatar: IMAGES.trans1,
        rating: 5,
        date: "January 10, 2024",
        comment:
            "Excellent tutor! My Spanish conversation skills have improved a lot.",
        subject: "Spanish",
    },
    {
        id: 4,
        studentName: "Ahmed Hassan",
        studentAvatar: IMAGES.trans1,
        rating: 4,
        date: "December 5, 2023",
        comment:
            "Helped me understand Arabic grammar better. Now I feel more confident speaking.",
        subject: "Arabic",
    },
    {
        id: 5,
        studentName: "Sophie Dubois",
        studentAvatar: IMAGES.trans1,
        rating: 3,
        date: "November 20, 2023",
        comment:
            "French lessons were good, but I needed more conversational practice.",
        subject: "French",
    },
    {
        id: 6,
        studentName: "Luca Bianchi",
        studentAvatar: IMAGES.trans1,
        rating: 5,
        date: "October 2, 2023",
        comment:
            "Fantastic Italian tutor! Improved my fluency and vocabulary a lot.",
        subject: "Italian",
    },
];

export const unavailableDays = [
    {
        id: 1,
        date: new Date("2025-03-29T16:45:00+05:00").toISOString(),
    },
    {
        id: 2,
        date: new Date("2025-03-30T16:45:00+05:00").toISOString(),
    },
    {
        id: 3,
        date: new Date("2025-03-30T16:45:00+05:00").toISOString(),
    },
    {
        id: 4,
        date: new Date("2025-04-05T16:45:00+05:00").toISOString(),
    },
    {
        id: 5,
        date: new Date("2025-04-06T16:45:00+05:00").toISOString(),
    },
];
